import Vue from 'vue'

import buildStore from './store'

// import store from './store'
import App from './components/App'

// import VueI18n from 'vue-i18n'
// import langMessages from './locale'

import { i18n } from './locale/i18n'

import { appConfig } from './store/config'

// NOPE
// import VueRouter from 'vue-router'
// Vue.use(VueRouter)

import uikit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

uikit.use(Icons)

// Vue.use(VueI18n)

// App.i18n = i18n

// App.store = buildStore(appConfig.state || {})

Vue.config.productionTip = false

new Vue({
  i18n,
  // store,
  store: buildStore(appConfig.state || {}),
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === 'development') {
  // PRODUCTION - remove app =
  // window.app = new Vue(App).$mount('#app')
  window.uikit = uikit
}/* else {
  new Vue(App).$mount('#app')
} */

require('./utils/polyfill.js')



// WEBPACK FOOTER //
// ./src/main.js